/**
 * Read XSRF-TOKEN cookie value for CSRF protection
 */
export function getCsrfToken() {
  const match = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]+)/)
  return match ? decodeURIComponent(match[1]) : null
}

/**
 * Return headers object with CSRF token if available
 */
export function csrfHeaders() {
  const token = getCsrfToken()
  return token ? { 'X-XSRF-TOKEN': token } : {}
}
